import { assert } from "../../../../../shared/utils/assert";
import { PublicationTemplateType } from "../../data/entities/publication-templates.entity";
import {
  FormToApiMapper,
  FormToPreviewMapper,
} from "../../domain/mappers/publication-template.mapper";
import { FormValue } from "../../../../../../harmony/angular";
import { PartialPublicationTemplate } from "../../domain/models/publication-template";
import { InstagramCarouselForm } from "./instagram-carousel-form/instagram-carousel-form.component";
import { InstagramCarouselCreateDto } from "./instagram-carousel.create-dto";

export class InstagramCarouselFormToApiMapper
  implements FormToApiMapper<InstagramCarouselForm, InstagramCarouselCreateDto>
{
  public map(
    form: FormValue<InstagramCarouselForm>,
  ): InstagramCarouselCreateDto {
    assert(!!form.media, "The post has no images");

    return {
      publicationTemplateType: PublicationTemplateType.InstagramCarousel,
      mediaIds: form.media.map((image) => image.id),
      text: form.text ?? undefined,
    };
  }
}

export class InstagramCarouselFormToPreviewMapper
  implements
    FormToPreviewMapper<
      InstagramCarouselForm,
      PublicationTemplateType.InstagramCarousel
    >
{
  public map(
    form: FormValue<InstagramCarouselForm>,
  ): PartialPublicationTemplate<PublicationTemplateType.InstagramCarousel> {
    return {
      type: PublicationTemplateType.InstagramCarousel,
      media: form.media?.length ? form.media : undefined,
      text: form.text ?? undefined,
    };
  }
}
